const UserTableHead = () => {
	return (
		<thead>
			<tr>
				<th
					scope="col"
					className="py-3.5 px-3 text-center text-sm font-semibold text-gray-900 "
					data-test="th-id"
				>
					Id
				</th>
				<th
					scope="col"
					className="py-3.5 px-3 text-center text-sm font-semibold text-gray-900"
					data-test="th-name"
				>
					Name
				</th>
				<th
					scope="col"
					className=" py-3.5 px-3 text-center text-sm font-semibold text-gray-900"
					data-test="th-email"
				>
					Email
				</th>
				<th
					scope="col"
					className=" py-3.5 px-3 text-center text-sm font-semibold text-gray-900"
					data-test="th-role"
				>
					Role
				</th>
				<th
					scope="col"
					className=" py-3.5 px-3 text-center text-sm font-semibold text-gray-900"
					data-test="th-profile"
				>
					Profile
				</th>
				<th
					scope="col"
					className="text-center px-3 text-sm font-semibold text-gray-900"
					data-test="th-status"
				>
					Status
				</th>
				<th
					scope="col"
					className="text-center px-3 text-sm font-semibold text-gray-900"
					data-test="th-status"
				>
					Subscription
				</th>
			</tr>
		</thead>
	);
};

export default UserTableHead;
